var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "deliverySheet" }, [
    _c(
      "div",
      {
        ref: "bigorder-print-single-body",
        staticClass: "print-body print-font print-single-body"
      },
      [
        _c("div", { staticClass: "title print-font" }, [_vm._v("发货清单")]),
        _vm._v(" "),
        _c("div", { staticClass: "ds-desc print-font" }, [
          _c("div", { staticClass: "top" }, [
            _c("span", [_vm._v("主单号：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.main_number))]),
            _vm._v(" "),
            _c("span", { staticClass: "send-date" }, [_vm._v("发货日期：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.out_ware_day))]),
            _vm._v(" "),
            _c("span", { staticClass: "delivery" }, [_vm._v("快递单号:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.courier_number))]),
            _vm._v(" "),
            _c("span", { staticClass: "delivery" }, [_vm._v("编号:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.serial_number))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btm" }, [
            _c("span", [_vm._v("收货方:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.receivingPhone))])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ds-table print-font" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.deliveryData, size: "small" }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", type: "index", width: "50" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "order_number",
                    label: "子订单号",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "ruigu_code", label: "商品编号", width: "95" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "name", label: "商品名称", "min-width": "250" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "unit", label: "单位", width: "45" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "send_amount", label: "数量", width: "45" }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "order-total print-font" }, [
          _c("span", [_vm._v("合计")]),
          _vm._v(" "),
          _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.total))])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { ref: "bigorder-print-group", staticClass: "print-group" }, [
      _c(
        "div",
        { staticClass: "print-delivery" },
        _vm._l(_vm.exportData, function(item) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.exportData.length !== 0,
                  expression: "exportData.length !== 0"
                }
              ],
              key: item.main_number,
              staticClass: "print-body print-font",
              staticStyle: { "page-break-after": "always" }
            },
            [
              _c("div", { staticClass: "title print-font" }, [
                _vm._v("发货清单")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ds-desc print-font" }, [
                _c("div", { staticClass: "top" }, [
                  _c("span", [_vm._v("主单号：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.main_number))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "send-date" }, [
                    _vm._v("发货日期：")
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.out_ware_day))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "delivery" }, [
                    _vm._v("快递单号:")
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.courier_number))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "delivery" }, [_vm._v("编号:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.serial_number))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btm" }, [
                  _c("span", [_vm._v("收货方:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.receivingPhone))])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ds-table print-font" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: item.list, fit: true }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", type: "index", width: "50" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "order_number",
                          label: "子订单号",
                          width: "120"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "ruigu_code",
                          label: "商品编号",
                          width: "95"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "商品名称",
                          "min-width": "250"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "unit", label: "单位", width: "45" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "send_amount",
                          label: "数量",
                          width: "45"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "order-total print-font" }, [
                _c("span", [_vm._v("合计")]),
                _vm._v(" "),
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(item.total))])
              ])
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "print-btn" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.myPrint }
          },
          [_vm._v("打印")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a2f97d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2f97d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigorder/delivery-sheet.vue
// module id = null
// module chunks = 